/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IImplant } from 'app/shared/model/implant.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IPatientProcedureOrder } from 'app/shared/model/patient-procedure-order.model';

export interface IPatientProcedureImplant {
  id?: string;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  quantity?: number;
  implanted?: boolean | null;
  implantRemoved?: boolean | null;
  implantUrl?: string | null;
  implant?: IImplant;
  patient?: IGlucoUser | null;
  order?: IPatientProcedureOrder;
}

export const defaultValue: Readonly<IPatientProcedureImplant> = {
  active: false,
  implanted: false,
  implantRemoved: false,
};
